import PageState from '../../Shared/pageState';
import controlDictionary from '../../Controls/controlDictionary';

export default (page: PageState): Record<string, unknown> => {
  let defaultValues: Record<string, unknown> = {};

  for (const control of page.controls) {
    defaultValues = {
      ...defaultValues,
      ...controlDictionary[control.kind].getDefaultValue(control)
    };
  }

  return defaultValues;
};
